import React, { useState } from "react";
import { Form, Button, Col, Container, Row } from "react-bootstrap";
import MapsAdvancedFilters from "./MapsAdvancedFilters";
import PostcodeInput from "../Common/PostcodeInput";

const MapsFilters = ({ onFilterChange, filters = {}, onSearch }) => {
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  return (
    <Container className="mt-4">
      <Form>
        <Row className="mb-3 g-2">
          <Col lg={2} md={4} sm={6}>
            <Form.Group controlId="cityName">
              <Form.Label>Miejscowość</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.cityName || ""}
                onChange={(e) => onFilterChange("cityName", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col lg={2} md={4} sm={6}>
            <Form.Group controlId="postcode">
              <Form.Label>Kod pocztowy</Form.Label>
              <PostcodeInput
                value={filters.postcode || ""}
                onChange={(val) => onFilterChange("postcode", val)}
                  inputMode="numeric"
              />
            </Form.Group>
          </Col>
          <Col lg={2} md={4} sm={6}>
            <Form.Group controlId="streetName">
              <Form.Label>Ulica</Form.Label>
              <Form.Control
                type="text"
                value={filters.Street ?? filters.streetName ?? ""}
                onChange={(e) => onFilterChange("Street", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col lg={2} md={4} sm={6}>
            <Form.Group controlId="terminalDR">
              <Form.Label>Terminal DR</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.terminalDR || filters.terminalDr || ""}
                onChange={(e) => onFilterChange("terminalDR", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col lg={2} md={4} sm={6}>
            <Form.Group controlId="terminalEX">
              <Form.Label>Terminal EX</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.terminalEX || filters.terminalEx || ""}
                onChange={(e) => onFilterChange("terminalEX", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col lg={2} md={4} sm={6} className="d-flex align-items-end">
            <Button
              variant="primary"
              type="button"
              className="w-100"
              style={{ backgroundColor: "#D40511", borderColor: "#D40511" }}
              onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
            >
              {showAdvancedFilters ? "Podstawowy" : "Zaawansowany"}
            </Button>
          </Col>
        </Row>
        {showAdvancedFilters && (
          <MapsAdvancedFilters onFilterChange={onFilterChange} />
        )}
      </Form>
    </Container>
  );
};

export default MapsFilters;
